import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import { BootstrapVueIcons } from 'bootstrap-vue'
import App from './App.vue'
import VueCarousel from 'vue-carousel'
import GoTop from '@inotom/vue-go-top'
import AOS from 'aos'
import 'aos/dist/aos.css'
import VueKinesis from "vue-kinesis"
import VueI18n from 'vue-i18n'
import router from './router'

/* Languages */
import { languages, defaultLocale } from '@/locales/index.js'
let currentLocale = 'en'
if (navigator.language === 'fr' || navigator.language === 'fr-FR') {
  currentLocale = 'fr'
}
const messages = Object.assign(languages)

/* Styles */
import '@/assets/theme.scss'


Vue.use(BootstrapVueIcons)
Vue.use(VueCarousel)
Vue.use(GoTop)
Vue.use(VueKinesis)
Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: currentLocale,
  fallbackLocale: defaultLocale,
  messages
})

Vue.config.productionTip = false

new Vue({
  created () {
    AOS.init({
      once: true
    })
  },
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
